import { createContext, useContext } from 'react';

export interface FormSearchContextValue {
  query: string;
  setQuery: (query: string) => void;
}

/**
 * The card form's field search. Provided by {@link FormSearchProvider}; null means no provider
 * above, and the form shows no search.
 */
export const FormSearchContext = createContext<FormSearchContextValue | null>(null);

export function useFormSearch() {
  return useContext(FormSearchContext);
}
